import { useQuery } from '@hooks/reactQuery';

import { getPortalFilesUsers } from '@api/portalFiles';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_FILES_USERS } from '@constants/queryKeys';

interface IUseQueryPortalFilesUsersReturned {
	portalFilesUsers: TNameTitleValueLabel[];
	isLoadingPortalFilesUsers: boolean;
}

export const useQueryPortalFilesUsers = (projectId?: string): IUseQueryPortalFilesUsersReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [GET_PORTAL_FILES_USERS, { projectId }],
		queryFn: extractQueryParams(getPortalFilesUsers),
		enabled: [projectId],
		allowedRoles: [EUserRoles.portalProjectAdministrator, EUserRoles.portalProjectMember],
		select: requestTypes => projectUsersFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalFilesUsers: data || [],
		isLoadingPortalFilesUsers: isInitialLoading,
	};
};
